import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { toDateOnlyString } from '../../../../core/date';
import { ReportParameterValues } from '../../report-parameters';
import { DatePeriodParameterOptions } from '../../report-parameters/parameters';
import { ReportColumnConfig } from '../../report-column';
import { ReportDefinition, ReportResponseDto } from '../../reporting.model';
import { ReportKey } from '../report-key.enum';

const reportColumnDefinition: ReportColumnConfig[] = [
            { key: 'transactionId', overrides: { order: 10, visible: true } },
            { key: 'transactionDate', overrides: { order: 20, visible: true } },
            { key: 'vendorName', overrides: { order: 30, visible: true } },
            { key: 'vendorLocationName', overrides: { order: 31, visible: true } },
            { key: 'lineDescription', overrides: { order: 40, visible: true, header: 'Transaction Description' } },
            { key: 'lineId', overrides: { order: 50, visible: true, header: 'Transaction Line Id' } },
            { key: 'contractFlag', overrides: { order: 60, visible: true } },
            { key: 'unitsGross', overrides: { order: 70, visible: true } },
            { key: 'unitsNet', overrides: { order: 80, visible: true } },
            { key: 'unitCost', overrides: { order: 90, visible: true } },
            { key: 'extendedCost', overrides: { order: 100, visible: true } },
            { key: 'sourceProductName', overrides: { order: 110, visible: true } },
            { key: 'productName', overrides: { order: 120, visible: true } },
            { key: 'sourceProductDesc', overrides: { order: 130, visible: true } },
            { key: 'productCategoryCostName', overrides: { order: 140, visible: true } },
            { key: 'transactionTypeName', overrides: { order: 150, visible: true } },
            { key: 'inventoryLocationId', overrides: { order: 160, visible: true } },
            { key: 'inventoryLocationName', overrides: { order: 170, visible: true } },
];

export const InventoryTransactionReport: ReportDefinition = {
    reportKey: ReportKey.InventoryTransaction,
    routePath: 'inventory-transaction',
    securityRuleKey: 'beta',
    reportColumnDefinition,
    parameters: [
        {
            key: 'datePeriod',
            overrides: {
                defaultValue: 'last3Months',
                options: {
                    datePeriods: [
                        { key: 'currentMonth' },
                        { key: 'yearToDate' },
                        { key: 'fiscalYearToDate' },
                        { key: 'last15Days' },
                        { key: 'last30Days' },
                        { key: 'last3Months' },
                        { key: 'custom' }
                    ]
                } as DatePeriodParameterOptions
            }
        },
        { key: 'productCategoryReportKeys' },
        { key: 'inventoryTransactionTypeKeys' }
    ],
    fetchData: fetchData,
    integrationEndpoint: 'v1/reports/inventory-transaction',
    buildIntegrationQueryParams: buildInventoryTransactionReportIntegrationQueryParams
};

function fetchData(httpClient: HttpClient, subscriberKey: number | null, params: ReportParameterValues): Observable<ReportResponseDto> {

    const body = {
        startDate: toDateOnlyString(params.startDate),
        endDate: toDateOnlyString(params.endDate),
        productCategoryReportKeys: params.productCategoryReportKeys,
        inventoryTransactionTypeKeys: params.inventoryTransactionTypeKeys,
    };

    return httpClient.post<ReportResponseDto>(`api/subscriber/${subscriberKey}/inventory/reports/inventory-transaction`, body);
}

function buildInventoryTransactionReportIntegrationQueryParams(params: ReportParameterValues): Record<string, string | string[]> {
    const result: Record<string, string | string[]> = {};

    const start = toDateOnlyString(params['startDate']);
    const end = toDateOnlyString(params['endDate']);
    if (start) result['startDate'] = start;
    if (end) result['endDate'] = end;

    const productCategoryReportKeys = params['productCategoryReportKeys'] as number[] | undefined;
    if (productCategoryReportKeys?.length) result['productCategoryReportKeys'] = productCategoryReportKeys.map(String);

    const transactionTypeKeys = params['inventoryTransactionTypeKeys'] as number[] | undefined;
    if (transactionTypeKeys?.length) result['transactionTypeKeys'] = transactionTypeKeys.map(String);

    return result;
}
